module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.1c59fe4c.m4a";